import React, { useState } from 'react';
import { HiSparkles } from 'react-icons/hi';

const Features = () => {
  const [expandedFeature, setExpandedFeature] = useState(null);

  const features = [
    {
      id: 1,
      name: 'Instant Brand Customization',
      description:
        "Automatically extract brand colors, fonts, logos, and style guidelines from your client's website or assets.",
    },
    {
      id: 2,
      name: 'Smart Scriptwriting',
      description:
        'AI-powered script generation that creates compelling ad copy tailored to your brand voice.',
    },
    {
      id: 3,
      name: 'Intuitive Editing Suite',
      description:
        'Drag-and-drop editor with real-time preview and professional-grade controls.',
    },
    {
      id: 4,
      name: 'AI Voices',
      description:
        'High-quality AI voiceovers in multiple languages and accents.',
    },
    {
      id: 5,
      name: 'Variations',
      description:
        'Generate multiple ad variations instantly to test and optimize performance.',
    },
    {
      id: 6,
      name: 'Translations',
      description:
        'Translate ads into multiple languages while maintaining brand consistency.',
    },
  ];

  return (
    <section className="relative min-h-screen flex items-center py-16 px-4 sm:px-6 lg:px-8 overflow-hidden bg-surface">
      <div className="relative z-10 w-full max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-12">
          {/* LEFT */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <HiSparkles className="text-brand" />
              <span className="text-brand text-sm font-semibold tracking-widest">
                FEATURES
              </span>
            </div>

            <h2 className="text-4xl md:text-5xl xl:text-6xl font-extrabold text-ink leading-tight mb-6">
              The Smarter Way to Create <br />
              <span className="text-brand">Video Ads</span>
            </h2>

            <p className="text-ink-muted text-lg max-w-xl mb-10">
              Turn your client’s existing assets into powerful, AI-generated,
              on-brand video ads in minutes.
            </p>

          </div>

          {/* RIGHT */}
          <div className="lg:col-span-2 space-y-4">
            {features.map((feature) => {
              const isOpen = expandedFeature === feature.id;

              return (
                <div
                  key={feature.id}
                  onClick={() =>
                    setExpandedFeature(isOpen ? null : feature.id)
                  }
                  className="border border-black/10 rounded-3xl cursor-pointer
                             transition-all hover:border-brand/50 hover:shadow-lg relative z-10 bg-white shadow-sm"
                >
                  <div className="flex justify-between items-center p-5">
                    <h4 className="text-ink font-medium text-lg">
                      {feature.name}
                    </h4>

                    <span
                      className={`text-brand transition-transform duration-300 ${
                        isOpen ? 'rotate-45' : ''
                      }`}
                    >
                      +
                    </span>
                  </div>

                  {isOpen && (
                    <div className="px-5 pb-5 text-ink-muted text-sm leading-relaxed">
                      {feature.description}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;
